module.exports = __webpack_public_path__ + "img/lifesize.162c986b.jpeg";